import { render, staticRenderFns } from "./DetallePTU.vue?vue&type=template&id=758fcd99&scoped=true"
import script from "./DetallePTU.vue?vue&type=script&lang=js"
export * from "./DetallePTU.vue?vue&type=script&lang=js"
import style0 from "./DetallePTU.vue?vue&type=style&index=0&id=758fcd99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758fcd99",
  null
  
)

export default component.exports